import { useCreateOne } from '@/queries/admin';
import { Form, FormData } from './Form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';

export const Create = () => {
  const { mutateAsync: createApplicationGroup } = useCreateOne('application-groups');
  const navigate = useNavigate();

  const onSubmit = async (data: FormData) => {
    try {
      await createApplicationGroup({ data });
      toast.success('Группа успешно создана');
      navigate(ROUTES.ADMIN.APPLICATION_GROUPS);
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Произошла ошибка при создании группы');
    }
  };

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Группы приложений',
          href: ROUTES.ADMIN.APPLICATION_GROUPS,
        },
        {
          label: 'Создание',
          href: '',
        },
      ]}
    >
      <Form onSubmit={onSubmit} />
    </PageLayout>
  );
};
